export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/37542aeac55b1d447e54ccd5b9415155.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8 max-w-5xl mx-auto">
        <h1 className="text-7xl font-extralight text-white leading-relaxed mb-8">
          Crafting Premium<br />iOS Experiences
        </h1>
        <p className="text-xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed">
          Expert team developing cutting-edge VPN and Cleaner solutions for enhanced mobile security and performance
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/40"></i>
      </div>
    </section>
  );
}